export default __webpack_public_path__ + "maps-examples-image-source-1200-e14c043cb6d371bac245fc802fd6eade.png";